"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetBookingStatuses = void 0;
var AssetBookingStatuses;
(function (AssetBookingStatuses) {
    /** cancelled */
    AssetBookingStatuses["Cancelled"] = "cancelled";
    /** confirmed */
    AssetBookingStatuses["Confirmed"] = "confirmed";
    /** pending */
    AssetBookingStatuses["Pending"] = "pending";
    /** all */
    AssetBookingStatuses["All"] = "all";
})(AssetBookingStatuses = exports.AssetBookingStatuses || (exports.AssetBookingStatuses = {}));
//# sourceMappingURL=bookingStatus.js.map